<template>
  <div v-if="termometria.dados && termometria.dados.length > 0" class="tw-w-full">
    <div :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-900'" class="tw-rounded-xl tw-p-4 tw-mb-6">
      <h4 :class="theme === 'dark' ? 'tw-text-slate-200' : 'tw-text-slate-700'" class="xs:tw-text-xs sm:tw-text-sm tw-font-semibold tw-mb-3">Informações climáticas no momento da leitura:</h4>
      <div v-if="termometria.estacao" class="tw-flex tw-items-center tw-gap-4 xs:tw-text-xs sm:tw-text-sm">
        <span class="tw-font-mono tw-font-bold">{{ termometria.estacao.temperatura }} °C</span>
        <span class="tw-font-mono tw-font-bold">{{ termometria.estacao.umidade }} %</span>
        <span :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" class="tw-text-xs">{{ termometria.data }}</span>
      </div>
      <div v-else :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" class="tw-text-sm">
        Sem dados de estação disponível
      </div>
    </div>
    <div class="tw-flex">
      <div :class="[
        'tw-rounded-2xl tw-p-1 tw-pb-6 tw-px-2 tw-min-w-max tw-flex tw-flex-col tw-justify-between tw-h-full tw-self-end',
        hasScrollbar && 'tw-mb-[8px]'
      ]">
        <div class="tw-flex tw-flex-col tw-gap-1">
          <div 
            v-for="sensor in maxSensores" 
            :key="sensor"
            @mouseover="sensorHover = (maxSensores - sensor) + 1"
            @mouseleave="sensorHover = null"
            :class="[
              'tw-rounded-lg tw-px-2 tw-py-1 tw-flex tw-items-center tw-justify-center tw-text-white tw-font-bold tw-text-sm tw-cursor-pointer tw-transition-all',
              sensorHover === ((maxSensores - sensor) + 1) 
                ? 'tw-bg-emerald-400 tw-ring-2 tw-ring-emerald-400' 
                : 'tw-bg-[#33b35a] hover:tw-ring-2 hover:tw-ring-emerald-400'
            ]"
          >
            S{{ (maxSensores - sensor) + 1 }}
          </div>
        </div>
      </div>
      <div class="tw-overflow-x-auto custom-scrollbar" ref="scrollContainer">
        <div class="tw-flex tw-gap-1 tw-min-w-max tw-pb-4">
          <div class="tw-flex tw-gap-1">
            <div 
              v-for="(cabo, index) in sortedCabos" 
              :key="index"
              :class="theme === 'dark' ? 'tw-bg-slate-700' : 'tw-bg-[#e9eef6]'"
              class="tw-rounded-2xl tw-p-1 tw-py-2 tw-min-w-max tw-flex tw-flex-col tw-justify-between tw-h-full"
            >
              <p :class="theme === 'dark' ? 'tw-text-slate-200' : 'tw-text-slate-800'" class="tw-font-bold tw-text-center tw-mb-4 tw-text-sm">
                Cabo {{ cabo.cabo }}
              </p>
              <div class="tw-flex tw-flex-col tw-gap-1">
                <div 
                  v-for="(sensor, index) in cabo.sensores" 
                  :key="index"
                  @mouseover="sensorHover = (cabo.sensores - sensor) + 1"
                  @mouseleave="sensorHover = null"
                  :class="[
                    'tw-min-w-[60px] tw-rounded-lg tw-px-1 tw-py-1 tw-text-center tw-font-bold tw-text-sm tw-text-black tw-cursor-pointer tw-transition-all',
                    sensorHover === ((cabo.sensores - sensor) + 1)
                      ? ['tw-ring-2 tw-scale-110', theme === 'dark' ? 'tw-ring-white' : 'tw-ring-black']
                      : 'hover:tw-ring-2 hover:tw-ring-emerald-400'
                  ]"
                  :style="{ backgroundColor: getCorPorTemperatura(cabo.temperaturas[`s${(cabo.sensores - sensor) + 1}`]) }"
                >
                  <span v-if="cabo.temperaturas[`s${(cabo.sensores - sensor) + 1}`] < 99">
                    {{ cabo.temperaturas[`s${(cabo.sensores - sensor) + 1}`] }} °C
                  </span>
                  <span v-else>OFF</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" class="tw-text-sm">
      Nenhuma leitura disponível    
    </div>
</template>

<script>
import temperaturaCores from "@/assets/colors.json";

export default {
    props: {
        termometria: {
            type: Object,
            default: () => {},
        },
        theme: {
            type: String,
            default: 'light'
        }
    },
    data() {
        return {
            sensorHover: null,
            hasScrollbar: false
        };
    },
    mounted() {
        this.checkScrollbar();
        if (this.$refs.scrollContainer) {
            const resizeObserver = new ResizeObserver(() => {
                this.checkScrollbar();
            });
            resizeObserver.observe(this.$refs.scrollContainer);
        }
    },
    computed: {
        sortedCabos() {
            return Array.isArray(this.termometria.dados)
                ? this.termometria.dados.slice().sort((a, b) => a.cabo - b.cabo)
                : [];      
        },
        maxSensores() {
          return this.termometria?.dados ? Math.max(...this.termometria.dados.map(c => c.sensores)) : 0;
        }
    },
    methods: {
        checkScrollbar() {
            if (this.$refs.scrollContainer) {
                this.hasScrollbar = this.$refs.scrollContainer.scrollWidth > this.$refs.scrollContainer.clientWidth;
            }
        },
        getCorPorTemperatura(temp) {
            temp = Number(temp);

            const faixas = Object.keys(temperaturaCores)
                .map(Number)
                .sort((a, b) => a - b);            

            for (let i = 0; i <= faixas.length - 1; i++) {
                if (temp <= faixas[i]) {
                    return temperaturaCores[faixas[i]];
                }
            }

            return "#c31313";
        }
    }
};
</script>
<style scoped>
.custom-scrollbar::-webkit-scrollbar {
    height: 8px;
}
</style>